import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgBuildingFill} from "~/assets/svg/building-fill.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBuildingFillIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBuildingFill id={id} className={cx(simpleIconStyles(size), commonStyles.strokeColor(color), className)} />;
};
